import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

import SidebarAdmin from "./Utils/SidebarAdmin";
import { logout } from "../apis/backend";

import "./Dashboard.css";
import "./CreateRound.css";

import CreateRounds from "./Resource/CreateRounds";
import UpdateRounds from "./Resource/UpdateRounds";
import LogoutButton from "./LogoutButton";

export default function CreateRound() {
  const navigate = useNavigate();

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className="dash-layout">
      {/* SIDEBAR */}
      <SidebarAdmin
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebar={() => setSidebarCollapsed((p) => !p)}
      />

      {/* MAIN CONTENT */}
      <div
        className={`dash-wrapper ${sidebarCollapsed ? "dash-wrapper-collapsed" : ""
          }`}
      >
        {/* NAVBAR / HEADER */}
        <header className="dash-header">
          <h1 className="dash-page-title">Create Rounds</h1>

          {/* PROFILE */}
          <div className="dash-user-profile">
            <div
              className="dash-profile-circle"
              onClick={() => setShowDropdown((p) => !p)}
            >
              <span>A</span>
            </div>

            {showDropdown && (
              <div className="dash-profile-dropdown">
                <LogoutButton />
              </div>
            )}
          </div>
        </header>

        {/* PAGE BODY */}
        <div className="dash-content-body">
          <CreateRounds />

          <UpdateRounds />
        </div>
      </div>
    </div>
  );
}
